import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  createdData: {},
  createPostLoader: false,
  postCreatedSuccess: false,
  createPostModal: false,
  postList: [],
  postPagination: {},
  error: null,
  isLoading: false,
};

const engagementFarmingSlice = createSlice({
  name: "engagementFarming",
  initialState,
  reducers: {
    createPostLoad: (state) => {
      state.createPostLoader = true;
      state.postCreatedSuccess = false;
    },

    createPostSuccess: (state, action) => {
      state.createPostLoader = false;
      state.postCreatedSuccess = true;
      state.createPostModal = false;
      state.createdData = action.payload;
    },
    createPostFail: (state) => {
      state.createPostLoader = false;
      state.postCreatedSuccess = false;
    },
    createPostModalHandler: (state) => {
      state.createPostModal = !state.createPostModal;
    },

    engagementFarmingListLoad(state) {
      state.isLoading = true;
      state.addCareSuccess = false;
      state.deleteCareSuccess = false;
    },
    engagementFarmingListSuccess(state, action) {
      const { list = [], pagination = {}, postDashboard = {} } = action.payload;
      state.isLoading = false;
      state.postList = list;
      state.postPagination = pagination;
      state.postDashboard = postDashboard;
    },
    engagementFarmingListFail(state) {
      state.isLoading = false;
      state.error = true;
    },

    dummyUserPostLikeLoad: (state) => {
      state.isPostLikeSuccess = false;
    },
    dummyUserpostLikeSuccess: (state, action) => {
      state.isPostLikeSuccess = true;
      state.lastCommentData = action.payload;
    },
    dummyUserpostLikeFail: (state, action) => {
      state.isPostLikeSuccess = false;
      state.lastCommentData = null;
    },

    dummyCreatePostLoad: (state) => {
      state.createPostLoader = true;
      state.postCreatedSuccess = false;
    },

    dummyCreatePostSuccess: (state, action) => {
      state.createPostLoader = false;
      state.postCreatedSuccess = true;
      state.createPostModal = false;
      state.createdData = action.payload;
    },
    dummyCreatePostFail: (state) => {
      state.createPostLoader = false;
      state.postCreatedSuccess = false;
    },
  },
});

export const {
  createPostLoad,
  createPostSuccess,
  createPostFail,
  createPostModalHandler,
  engagementFarmingListLoad,
  engagementFarmingListSuccess,
  engagementFarmingListFail,
  dummyUserPostLikeLoad,
  dummyUserpostLikeSuccess,
  dummyUserpostLikeFail,
  dummyCreatePostLoad,
  dummyCreatePostSuccess,
  dummyCreatePostFail,
} = engagementFarmingSlice.actions;

export default engagementFarmingSlice.reducer;
